function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
  class SectionId {
    static #separator = '__';
  
    // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
    static parseId(qualifiedSectionId) {
      return qualifiedSectionId.split(SectionId.#separator)[0];
    }
  
    // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
    static parseSectionName(qualifiedSectionId) {
      return qualifiedSectionId.split(SectionId.#separator)[1];
    }
  
    // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
    static getIdForSection(sectionId, sectionName) {
      return `${sectionId}${SectionId.#separator}${sectionName}`;
    }
  }
  
  class HTMLUpdateUtility {
    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
      preProcessCallbacks?.forEach((callback) => callback(newContent));
  
      const newNodeWrapper = document.createElement('div');
      HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
      const newNode = newNodeWrapper.firstChild;
  
      // dedupe IDs
      const uniqueKey = Date.now();
      oldNode.querySelectorAll('[id], [form]').forEach((element) => {
        element.id && (element.id = `${element.id}-${uniqueKey}`);
        element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
      });
  
      oldNode.parentNode.insertBefore(newNode, oldNode);
      oldNode.style.display = 'none';
  
      postProcessCallbacks?.forEach((callback) => callback(newNode));
  
      setTimeout(() => oldNode.remove(), 500);
    }
  
    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');
  
    if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
      return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch {
    focusVisiblePolyfill();
  }
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if(navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
      if (mouseClick) return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    }, true);
  }
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
  }
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
  document.querySelectorAll('.custom_dropm details').forEach(details => {
    const summary = details.querySelector('summary');
    const closeOtherMenus = () => {
      document.querySelectorAll('.custom_dropm details[open]').forEach(otherDetails => {
        if (otherDetails !== details) {
          otherDetails.removeAttribute('open');
          const otherSummary = otherDetails.querySelector('summary');
          otherSummary.setAttribute('aria-expanded', false);
        }
      });
    };
    details.addEventListener('toggle', closeOtherMenus);
    summary.addEventListener('keydown', (event) => {
      if (event.code === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        closeOtherMenus();
        details.toggleAttribute('open');
        summary.setAttribute('aria-expanded', details.open);
      }
    });
    summary.addEventListener('focus', closeOtherMenus);
    details.addEventListener('focusout', (event) => {
      const relatedTarget = event.relatedTarget;
      if (!details.contains(relatedTarget)) {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', false);
      }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.code === 'Tab') {
      const openDetails = document.querySelector('.custom_dropm details[open]');
      if (openDetails && !document.activeElement.closest('.custom_dropm')) {
        openDetails.removeAttribute('open');
        const summaryElement = openDetails.querySelector('summary');
        summaryElement.setAttribute('aria-expanded', false);
      }
    }
  });
  // class QuantityInput extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.input = this.querySelector('input');
  //     this.changeEvent = new Event('change', { bubbles: true })
  //     this.querySelectorAll('button').forEach(
  //       (button) => button.addEventListener('click', this.onButtonClick.bind(this))
  //     );
  //   }
  //   onButtonClick(event) {
  //     event.preventDefault();
  //     const previousValue = this.input.value;
  
  //     event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
  //     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  //   }
  // }
  // customElements.define('quantity-input', QuantityInput);
  
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.qAddBtn = this.querySelector('button[name="qAdd"]');
      this.minusBtn = this.querySelector('button[name="minus"]');
      this.plusBtn = this.querySelector('button[name="plus"]');
      this.quantityButtons = this.querySelectorAll('.quantity__button');
      this.quantityInput = this.querySelector('.quantity__input');
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = parseInt(this.input.value);
      const btnName = event.target.name;
      if (btnName === 'qAdd') {
        this.input.value = 1;
        this.quantityButtons.forEach(btn => btn.classList.remove('hidden'));
        this.quantityInput.classList.remove('hidden');
        this.qAddBtn.classList.add('hidden');
      }
      if (btnName === 'plus') {
        this.input.stepUp();
      }
      if (btnName === 'minus') {
        this.input.stepDown();
      }
      if (previousValue !== parseInt(this.input.value)) {
        this.input.dispatchEvent(this.changeEvent);
      }
      if (parseInt(this.input.value) <= 0) {
        this.input.value = 0;
        this.quantityButtons.forEach(btn => btn.classList.add('hidden'));
        this.quantityInput.classList.add('hidden');
        this.qAddBtn.classList.remove('hidden');
      }
    }
  }
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  /* * Shopify Common JS* */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  Shopify.bind = function(fn, scope) {
    return function() {
      return fn.apply(scope, arguments);
    }
  };
  Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
  };
  Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for(var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
    this.initCountry();
    this.initProvince();
  };
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
    initProvince: function() {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
    countryHandler: function(e) {
      var opt       = this.countryEl.options[this.countryEl.selectedIndex];
      var raw       = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function(selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
    setOptions: function(selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
        const elapsedTime = time - animationStart;
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('menu-drawer', MenuDrawer);
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      this.header.classList.add('menu-open');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
    }
  }
  customElements.define('header-drawer', HeaderDrawer);
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
    hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
      }
    }
  }
  customElements.define('deferred-media', DeferredMedia);
  // class SliderComponent extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.slider = this.querySelector('[id^="Slider-"]');
  //     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
  //     this.enableSliderLooping = false;
  //     this.currentPageElement = this.querySelector('.slider-counter--current');
  //     this.pageTotalElement = this.querySelector('.slider-counter--total');
  //     this.prevButton = this.querySelector('button[name="previous"]');
  //     this.nextButton = this.querySelector('button[name="next"]');
  //     if (!this.slider || !this.nextButton) return;
  //     this.initPages();
  //     const resizeObserver = new ResizeObserver(entries => this.initPages());
  //     resizeObserver.observe(this.slider);
  //     this.slider.addEventListener('scroll', this.update.bind(this));
  //     this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
  //     this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  //   }
  //   initPages() {
  //     this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
  //     if (this.sliderItemsToShow.length < 2) return;
  //     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
  //     this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
  //     this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
  //     this.update();
  //   }
  //   resetPages() {
  //     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
  //     this.initPages();
  //   }
  //   update() {
  //     const previousPage = this.currentPage;
  //     this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  //     if (this.currentPageElement && this.pageTotalElement) {
  //       this.currentPageElement.textContent = this.currentPage;
  //       this.pageTotalElement.textContent = this.totalPages;
  //     }
  //     if (this.currentPage != previousPage) {
  //       this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
  //         currentPage: this.currentPage,
  //         currentElement: this.sliderItemsToShow[this.currentPage - 1]
  //       }}));
  //     }
  //     if (this.enableSliderLooping) return;
  //     if (this.isSlideVisible(this.sliderItemsToShow[0])) {
  //       this.prevButton.setAttribute('disabled', 'disabled');
  //     } else {
  //       this.prevButton.removeAttribute('disabled');
  //     }
  //     if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], -1)) {
  //       this.nextButton.setAttribute('disabled', 'disabled');
  //     } else {
  //       this.nextButton.removeAttribute('disabled');
  //     }
  //   }
  //   isSlideVisible(element, offset = 0) {
  //     const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
  //     return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  //   }
  //   onButtonClick(event) {
  //     event.preventDefault();
  //     const step = event.currentTarget.dataset.step || 1;
  //     this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
  //     this.slider.scrollTo({
  //       left: this.slideScrollPosition
  //     });
  //   }
  // }
  // customElements.define('slider-component', SliderComponent);
  
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
      
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
      
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      if (this.sliderItems.length < 2) return;
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      
      if (this.sliderItemsToShow.length < 2) return;
      
      const firstItem = this.sliderItemsToShow[0];
      const secondItem = this.sliderItemsToShow[1];
      
      if (!firstItem || !secondItem) return;
  
      this.sliderItemOffset = secondItem.offsetLeft - firstItem.offsetLeft;
  
      if (this.sliderItemOffset === 0) return;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], -1)) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      if (!element) return false;
  
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
  
      if (this.sliderItemOffset === 0) return;
  
      this.slideScrollPosition = event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + (step * this.sliderItemOffset)
        : this.slider.scrollLeft - (step * this.sliderItemOffset);
  
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
  customElements.define('slider-component', SliderComponent);
  
  
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
      if (!this.sliderControlWrapper) return;
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();

      // custom code
      this.extraVisibleElement = 0;
      this.sliderItemsToShow.forEach(ele => {
        if(this.isElementVisible(ele)) this.extraVisibleElement++;
      });
      if(this.extraVisibleElement!=0) this.extraVisibleElement--;

      // Clone slides for infinite loop: 1,2,3 → 1,2,3,[clone1,clone2,clone3]
      this._cloneSetup();

      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    _cloneSetup() {
      const origSlides = Array.from(this.slider.querySelectorAll('.slideshow__slide'));
      if (origSlides.length < 2) return;
      this._origCount = origSlides.length;

      // Append clones at end
      origSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-clone', 'true');
        // Remove IDs to avoid duplicates
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        this.slider.appendChild(clone);
      });

      // When user scrolls into clone area → silently reset to real slide
      this.slider.addEventListener('scroll', () => {
        const sw = this.sliderFirstItemNode.offsetWidth;
        const realEnd = sw * this._origCount; // scroll position after last real slide

        if (this.slider.scrollLeft >= realEnd) {
          // Silently jump back — which clone position maps to which real slide
          const offset = this.slider.scrollLeft - realEnd;
          this._jumpTo(offset);
        }
      }, { passive: true });
    }
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  
    // custom code
    isElementVisible(element){
      const rect = element.getBoundingClientRect();
      const rect1 = this.getBoundingClientRect();
  
      return (
        rect.left >=  rect1.left &&
        rect.right <= rect1.right
      );
    };
  
    onButtonClick(event) {
      event.preventDefault();
      const slideWidth = this.sliderFirstItemNode.offsetWidth;

      if (event.currentTarget.name === 'next') {
        // Next: always scroll forward — clone at end handles the wrap
        this.slider.scrollTo({ left: this.slider.scrollLeft + slideWidth, behavior: 'smooth' });
      } else {
        // Prev: if on slide 1, jump to last real slide
        if (this.slider.scrollLeft <= 0) {
          const lastRealPos = slideWidth * (this._origCount - 1);
          this._jumpTo(lastRealPos);
        } else {
          this.slider.scrollTo({ left: this.slider.scrollLeft - slideWidth, behavior: 'smooth' });
        }
      }
    }

    _jumpTo(scrollLeft) {
      this.slider.style.setProperty('scroll-behavior', 'auto', 'important');
      this.slider.scrollLeft = scrollLeft;
      void this.slider.scrollLeft;
      this.slider.style.removeProperty('scroll-behavior');
    }
    // update() {
    //   super.update();
    //   this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    //   this.prevButton.removeAttribute('disabled');
    //   if (!this.sliderControlButtons.length) return;
    //   this.sliderControlButtons.forEach(link => {
    //     link.classList.remove('slider-counter__link--active');
    //     link.removeAttribute('aria-current');
    //   });
    //   this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    //   this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    // }
  
    update() {
    super.update();
  
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
  
    if (!this.sliderControlButtons.length) return;
  
    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
  
    const activeButton = this.sliderControlButtons[this.currentPage - 1];
    if (activeButton) {
      activeButton.classList.add('slider-counter__link--active');
      activeButton.setAttribute('aria-current', 'true');
    }
  }
  
  
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
    // autoRotateSlides() {
    //   const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    //   this.slider.scrollTo({
    //     left: slideScrollPosition
    //   });
    // }
  
    autoRotateSlides() {
      const slideWidth = this.sliderFirstItemNode.offsetWidth;
      // Always scroll forward — clone at end handles infinite wrap
      this.slider.scrollTo({ left: this.slider.scrollLeft + slideWidth, behavior: 'smooth' });
    }
    
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const button = item.querySelector('a');
        if (index === this.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
  
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      //this.addEventListener('change', this.onVariantChange);
    }
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateSelectionMetadata(event);
        
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
    }
  
    updateSelectionMetadata({ target }) {
      const { value, tagName } = target;
  
      if (tagName === 'SELECT' && target.selectedOptions.length) {
        Array.from(target.options)
          .find((option) => option.getAttribute('selected'))
          .removeAttribute('selected');
        target.selectedOptions[0].setAttribute('selected', 'selected');
  
        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        const selectedDropdownSwatchValue = target
          .closest('.product-form__input')
          .querySelector('[data-selected-value] > .swatch');
        if (!selectedDropdownSwatchValue) return;
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
          selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
        } else {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
          selectedDropdownSwatchValue.classList.add('swatch--unavailable');
        }
  
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch-focal-point',
          target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
        );
      } else if (tagName === 'INPUT' && target.type === 'radio') {
        const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
  
        const selectedOptionGroup = target.closest(`.product-form__input`);
        if (selectedOptionGroup) {
          selectedOptionGroup?.querySelectorAll('label')?.forEach((option) => option.classList.remove('selected'));
          target.closest('label')?.classList.add('selected');
        }
      }
    }
    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
    
    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }
  }
  customElements.define('variant-selects', VariantSelects);
  
  
  // Variant for tab product 
  class VariantTabSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterId();
      this.updateSelectedSwatchValue(event);
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantValue();
      this.updateSoldOutBadge();
      this.updateContinueselling();
      this.updateVariantStatuses();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        if (this.dataset.layout == 'card') {
          this.updateMedia();
        }
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
        this.updateCardURL();
        this.updateSku();
        this.updateStockCountdown();
  
      }
    }
    updateSoldOutBadge() {
      const card = this.closest('.card-wrapper');
      const soldOutBadge = card?.querySelectorAll('.soldout_product_badge');
      if (soldOutBadge  && soldOutBadge.length == 1) {
        const isAvailable = this.currentVariant && this.currentVariant.available;
        soldOutBadge[0].classList.toggle('hidden', isAvailable);
      }
    }
  
    updateContinueselling() {
      if (!this.currentVariant) return;
      let productMain = this.closest('.card-wrapper');
      if (productMain && productMain.querySelector('.card__badge') != null) {
        let variantsData = JSON.parse(productMain.querySelector('#card-product-variants').innerHTML);
        let variant = this.currentVariant;
        if (variantsData[variant.id]['q'] > 0 && variant.inventory_management == 'shopify') {
          productMain.querySelector('.continue_product_badge').classList.add('hidden');
        } 
        else if (variantsData[variant.id]['p'] == "continue") {
          productMain.querySelector('.continue_product_badge').classList.remove('hidden');
        }
        else {
          productMain.querySelector('.continue_product_badge').classList.add('hidden');
        }
      }
    }
    updateVariantValue() {
      if (this.dataset.layout == 'button') {
        event.target.closest('fieldset').querySelector('legend span').innerHTML = event.target.value
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
        if (element.tagName === 'SELECT') {
          return element.value;
        }
        if (element.tagName === 'FIELDSET') {
          return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        }
      });
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  
    updateSelectedSwatchValue({ target }) {
      const { name, value, tagName } = target;
  
      if (tagName === 'SELECT' && target.selectedOptions.length) {
        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
        if (!selectedDropdownSwatchValue) return;
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
          selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
        } else {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
          selectedDropdownSwatchValue.classList.add('swatch--unavailable');
        }
  
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch-focal-point',
          target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
        );
      } else if (tagName === 'INPUT' && target.type === 'radio') {
        const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      }
    }
    updateSku() {
      if (!this.currentVariant) return;
      let productMain = this.closest('.product');
      if (productMain && productMain.querySelector('.variant-sku') != null) {
        productMain.querySelector('.variant-sku').innerHTML = this.currentVariant.sku;
      }
    }
    updateStockCountdown() {
      if (!this.currentVariant) return;
      let productMain = this.closest('.product');
      if (productMain && productMain.querySelector('.wbstockcount') != null) {
        let variantsData = JSON.parse(productMain.querySelector('#product-variants').innerHTML);
        let stockCountdownConfig = JSON.parse(productMain.querySelector('#product-stock-countdown-config').innerHTML);
        let variant = this.currentVariant;
        let countdownWrapper = productMain.querySelector('.wbstockcount');
        if (variantsData[variant.id]['q'] > 0 && variant.inventory_management == 'shopify') {
          productMain.querySelector('.wbstockcount').classList.remove('hidden');
          productMain.querySelector('.wbstockinfo-bar').classList.remove('hidden');
          if (variantsData[variant.id]['q'] > stockCountdownConfig.limited_stock_cut_off) { // High Stock
            countdownWrapper.querySelector('.wbstockinfo').classList.remove('wbstockinfo_low', 'wbstockinfo_soon');
            countdownWrapper.querySelector('.wbstockinfo').classList.add('wbstockinfo_high');
            countdownWrapper.querySelector('.wbstockinfo').innerHTML = stockCountdownConfig.instock_message.replace('{stock_number}', variantsData[variant.id]['q']);
            countdownWrapper.querySelector('.wbstockinfo-probar').style.width = ((variantsData[variant.id]['q'] * 100) / stockCountdownConfig.max_stock) + '%';
          } else { // Low Stock
            countdownWrapper.querySelector('.wbstockinfo').classList.replace('wbstockinfo_soon', 'wbstockinfo_low');
            countdownWrapper.querySelector('.wbstockinfo').classList.add('wbstockinfo_low');
            countdownWrapper.querySelector('.wbstockinfo').innerHTML = stockCountdownConfig.limited_stock_message.replace('{stock_number}', variantsData[variant.id]['q']);
            countdownWrapper.querySelector('.wbstockinfo-probar').style.width = ((variantsData[variant.id]['q'] * 100) / stockCountdownConfig.max_stock) + '%';
          }
        } 
        else if (variantsData[variant.id]['p'] == "continue") {
          productMain.querySelector('.wbstockcount').classList.remove('hidden');
          productMain.querySelector('.wbstockinfo-bar').classList.add('hidden');
          countdownWrapper.querySelector('.wbstockinfo').classList.remove('wbstockinfo_low', 'wbstockinfo_high');
          countdownWrapper.querySelector('.wbstockinfo').classList.add('wbstockinfo_soon');
          countdownWrapper.querySelector('.wbstockinfo').innerHTML = stockCountdownConfig.continue_selling_message.replace();
        }
        else {
          productMain.querySelector('.wbstockcount').classList.add('hidden');
        }
      }
    }
    updateMedia(html) {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      if (this.dataset.layout == 'card') {
        const card = this.closest('.card');
        const newMedia = card.querySelector(
          `[data-media-id="${this.dataset.section}-${this.dataset.block}-${this.dataset.product}-${this.currentVariant.featured_media.id}"]`
        );
        if (!newMedia) return;
        const modalContent = card.querySelector('.card__media');
        const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        parent.prepend(newMedia);
  
  
      } else {
  
  
        const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
        const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
  
        const refreshSourceData = () => {
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };
  
        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;
  
          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }
  
          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }
  
          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
  
          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
  
            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );
  
              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }
  
        if (this.currentVariant.featured_media) {
        document
          .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
          ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
        }
  
        // update media modal
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }
    }
  
    updateCardURL() {
      if (this.dataset.layout == 'card') {
        const card = this.closest('.card');
        const modalContent = card.querySelector('.card__media');
        const productAnchor = modalContent.querySelector('a');
        const productTitle = card.querySelector('.product-title');
        const productTitleAnchor = productTitle.querySelector('a');
        const productQuickview = card.querySelector('.js-wbquickview-link');
        let productURL = this.updateURLParameter(this.dataset.url, 'variant', this.currentVariant.id);
        productAnchor.setAttribute('href', productURL);
        productTitleAnchor.setAttribute('href', productURL);
        if (productQuickview) {
          productQuickview.setAttribute('variant-id', this.currentVariant.id);
        }
      }
    }
  
    updateURLParameter(url, param, paramVal){
      var newAdditionalURL = "";
      var tempArray = url.split("?");
      var baseURL = tempArray[0];
      var additionalURL = tempArray[1];
      var temp = "";
      if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (var i=0; i<tempArray.length; i++){
          if(tempArray[i].split('=')[0] != param){
            newAdditionalURL += temp + tempArray[i];
            temp = "&";
          }
        }
      }
      var rows_txt = temp + "" + param + "=" + paramVal;
      return baseURL + "?" + newAdditionalURL + rows_txt;
    }
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}-${this.dataset.block}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
  
      // Variant in Product Card
      if (this.dataset.layout == 'card') {
        const card = this.closest('.card');
        const productForms = card.querySelectorAll(`#ProductInfo-${this.dataset.section}-${this.dataset.block}-${this.dataset.product}`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelectorAll('input[name="id"]');
          Array.from(input).forEach((element,index) =>
          {
            element.value = this.currentVariant.id;
          });
          const select = productForm.querySelectorAll('select[name="id"]');
          Array.from(select).forEach((element,index) =>
          {
            element.value = this.currentVariant.id;
          });
  
          const fieldsets = Array.from(this.querySelectorAll('fieldset'));
          fieldsets.forEach(function(option) {
            Array.from(option.querySelectorAll('label')).find((element) => element.classList.remove('active'));
          });
          const optionData = this.closest('.grid__item').querySelectorAll('select option');
          const regularPrice = this.closest('.grid__item').querySelector('.price .price__container .price__regular .price-item--regular');
          const saleRegularPrice = this.closest('.grid__item').querySelector('.price .price__container .price__sale .price-item--sale');
          const salePrice = this.closest('.grid__item').querySelector('.price .price__container .price__sale .price-item--regular');
          const wbunitPrice = this.closest('.grid__item').querySelector('.price .price__container .unit-price .cardunitp');
          const wbunitValue = this.closest('.grid__item').querySelector('.price .price__container .unit-price .cardunitv');
            
          const wbPercentBadge = this.closest('.grid__item').querySelector('.card__badge .percent__badge-sale');
          const wbAmountBadge = this.closest('.grid__item').querySelector('.card__badge .amount__badge-sale');
          
          optionData.forEach((data) => {
            if(data.value == this.currentVariant.id) {
              if(data.dataset.cprice != '' &&  data.dataset.price != data.dataset.cprice) {
                saleRegularPrice.innerHTML = data.dataset.price;
                salePrice.innerHTML = data.dataset.cprice;
                if(data.dataset.damount != '') {
                  wbAmountBadge.innerHTML = data.dataset.damount;
                  wbAmountBadge.classList.remove('hidden');
                }
                if(data.dataset.percent != '') {
                  wbPercentBadge.innerHTML = data.dataset.percent;
                  wbPercentBadge.classList.remove('hidden');
                }
                this.closest('.grid__item').querySelector('.price').classList.add("price--on-sale");
              }
              else {
                regularPrice.innerHTML = data.dataset.price;
                if(wbPercentBadge){
                  wbPercentBadge.classList.add('hidden');
                }
                if(wbAmountBadge){
                  wbAmountBadge.classList.add('hidden');
                }
                this.closest('.grid__item').querySelector('.price').classList.remove("price--on-sale");
              }
              if(data.dataset.unitprice) {
                wbunitPrice.innerHTML = data.dataset.unitprice;
                this.closest('.grid__item').querySelector('.price').classList.add("price--on-sale");
              }
              if(data.dataset.unitvalue) {
                wbunitValue.innerHTML = data.dataset.unitvalue;
                this.closest('.grid__item').querySelector('.price').classList.add("price--on-sale");
              }
            }
          });
        });
        return;
      }
  
  
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}-${this.dataset.block}, #product-form-installment-${this.dataset.section}-${this.dataset.block}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  
    }
    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
          //input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      let sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
      if (this.dataset.layout == 'card') {
        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            if (this.currentVariant.id !== requestedVariantId) return;
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            sectionId = `${sectionId}-${this.dataset.product}`;
            publish(PUB_SUB_EVENTS.variantChange, {data: {
                sectionId,
                html,
                variant: this.currentVariant
              }});
  
          })
        // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        return;
      }
  
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant.id !== requestedVariantId) return;
  
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destinations = document.querySelectorAll(`#price-${this.dataset.section}`);
            const sources = html.querySelectorAll(`#price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
            const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
            const volumePricingSource = html.getElementById(
              `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
  
            
            if (this.dataset.layout != 'card') {
              this.updateMedia(html);
            }
            const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
            const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
  
            const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
            const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
            const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
  
            if (volumeNote) volumeNote.classList.remove('hidden');
            if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
            if (qtyRules) qtyRules.classList.remove('hidden');
  
            if (sources.length == destinations.length && sources.length != 0){
              let idx = 0;
              for(let source of sources){
                destinations[idx].innerHTML = source.innerHTML;
                idx++;
              }
            }
            if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
            }
  
            if (volumePricingSource && volumePricingDestination) {
              volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
            }
  
            if (pricePerItemSource && pricePerItemDestination) {
              pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
              pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
            }
  
            const price = document.getElementById(`price-${this.dataset.section}-${this.dataset.block}`);
  
            if (price) price.classList.remove('hidden');
  
            if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
  
            const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
  
            publish(PUB_SUB_EVENTS.variantChange, {data: {
                sectionId,
                html,
                variant: this.currentVariant
              }});
          });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      // Variant in Product Card
      var selector = `product-form-${this.dataset.section}-${this.dataset.block}`;
      if (this.dataset.layout == 'card') {
        selector = `product-form-${this.dataset.section}-${this.dataset.block}-${this.dataset.product}`;
      }
      const productForm = document.getElementById(selector);
  
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
  
      // Variant in Product Card
      var selector = `product-form-${this.dataset.section}-${this.dataset.block}`;
      var priceSelector = `price-${this.dataset.section}-${this.dataset.block}`;
      var button = document.getElementById(`product-form-${this.dataset.section}-${this.dataset.block}`);
      if (this.dataset.layout == 'card') {
        selector = `product-form-${this.dataset.section}-${this.dataset.block}-${this.dataset.product}`;
        priceSelector = `price-${this.dataset.section}-${this.dataset.block}-${this.dataset.product}`;
        button = document.getElementById(`product-form-${this.dataset.section}-${this.dataset.block}-${this.dataset.product}`);
      }
  
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}-${this.dataset.block}`);
      const inventory = document.getElementById(`Inventory-${this.dataset.section}-${this.dataset.block}`);
      const sku = document.getElementById(`Sku-${this.dataset.section}-${this.dataset.block}`);
      const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}-${this.dataset.block}`);
      const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}-${this.dataset.block}`);
      const volumeTable = document.getElementById(`Volume-${this.dataset.section}-${this.dataset.block}`);
      const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}-${this.dataset.block}`);
  
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      // if (price) price.classList.add('hidden');
      if (inventory) inventory.classList.add('hidden');
      if (sku) sku.classList.add('hidden');
      if (pricePerItem) pricePerItem.classList.add('hidden');
      if (volumeNote) volumeNote.classList.add('hidden');
      if (volumeTable) volumeTable.classList.add('hidden');
      if (qtyRules) qtyRules.classList.add('hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-tab-selects', VariantTabSelects);
  class VariantTabRadios extends VariantTabSelects {
    constructor() {
      super();
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  customElements.define('variant-tab-radios', VariantTabRadios);
  // Variant for tab product over
  
  document.addEventListener('DOMContentLoaded', function () {
    var comparisonSliders = document.querySelectorAll(".comparison-slider");
    if (comparisonSliders.length > 0) {
        comparisonSliders.forEach(function (compSlider) {
            var compSliderWidth = compSlider.offsetWidth + "px";
            compSlider.querySelector(".resize .compare__image").style.width = compSliderWidth;
            drags(compSlider.querySelector(".divider"), compSlider.querySelector(".resize"), compSlider);
        });
        window.addEventListener("resize", function () {
            comparisonSliders.forEach(function (compSlider) {
                var compSliderWidth = compSlider.offsetWidth + "px";
                compSlider.querySelector(".resize .compare__image").style.width = compSliderWidth;
            });
        });
    }
  });
  
  function drags(dragElement, resizeElement, container) {
    var touched = false;
  
    // Detect touch events
    window.addEventListener('touchstart', function () {
        touched = true;
    });
    window.addEventListener('touchend', function () {
        touched = false;
    });
  
    dragElement.addEventListener("mousedown", startDragging);
    dragElement.addEventListener("touchstart", startDragging);
  
    function startDragging(e) {
        e.preventDefault();
        
        dragElement.classList.add("draggable");
        resizeElement.classList.add("resizable");
  
        // Get the initial position of the drag
        var startX = e.pageX || (e.touches && e.touches[0] ? e.touches[0].pageX : 0);
        if (!startX) return; // Guard against undefined touches
  
        var dragWidth = dragElement.offsetWidth;
        var posX = dragElement.offsetLeft + dragWidth - startX;
        var containerOffset = container.offsetLeft;
        var containerWidth = container.offsetWidth;
        var minLeft = containerOffset + 10;
        var maxLeft = containerOffset + containerWidth - dragWidth - 10;
  
        function dragMove(e) {
            if (!touched) {
                e.preventDefault();
            }
            var moveX = e.pageX || (e.touches && e.touches[0] ? e.touches[0].pageX : 0);
            if (!moveX) return; // Guard against undefined touches
  
            var leftValue = moveX + posX - dragWidth;
            if (leftValue < minLeft) {
                leftValue = minLeft;
            } else if (leftValue > maxLeft) {
                leftValue = maxLeft;
            }
  
            var widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth) + "%";
            dragElement.style.left = widthValue;
            resizeElement.style.width = widthValue;
        }
  
        function dragEnd() {
            dragElement.classList.remove("draggable");
            resizeElement.classList.remove("resizable");
            document.removeEventListener("mousemove", dragMove);
            document.removeEventListener("mouseup", dragEnd);
            document.removeEventListener("touchmove", dragMove);
            document.removeEventListener("touchend", dragEnd);
            document.removeEventListener("touchcancel", dragEnd);
        }
  
        document.addEventListener("mousemove", dragMove);
        document.addEventListener("mouseup", dragEnd);
        document.addEventListener("touchmove", dragMove);
        document.addEventListener("touchend", dragEnd);
        document.addEventListener("touchcancel", dragEnd);
    }
  }
  
  
  // account avatar
  class AccountIcon extends HTMLElement {
    constructor() {
      super();
  
      this.icon = this.querySelector('.icon');
    }
  
    connectedCallback() {
      document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
    }
  
    handleStorefrontSignInCompleted(event) {
      if (event?.detail?.avatar) {
        this.icon?.replaceWith(event.detail.avatar.cloneNode());
      }
    }
  }
  
  customElements.define('account-icon', AccountIcon); 
  
  // Lookbook Active
  class LookBook extends HTMLElement {
    constructor() {
      super();
      this.lookbookpoints = this.querySelectorAll('div.wblookbook button');
      this.lookbookpoints.forEach((lookbookpoint) => {
        lookbookpoint.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
    onButtonClick(event) {
      var element = document.getElementById("wblook" + event.target.dataset.no + "-" + event.target.dataset.sectionid);
      this.querySelectorAll('div.wblookbleft').forEach((lookbookproduct) => {
        lookbookproduct.classList.remove('active');
      });
      this.lookbookpoints.forEach((lookbookpointbtn) => {
        lookbookpointbtn.classList.remove('active');
      });
      element.classList.add('active');
      event.target.classList.add('active');
    }
  }
  customElements.define('look-book', LookBook);
  
  
  
  
  // search prepend
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 991) {
        var hdrtop = document.querySelector('.hdrtop');
        var tright = document.querySelector('.tright');
        if (hdrtop && tright && !tright.contains(hdrtop)) {
            tright.prepend(hdrtop);
        }
    }
  });
  // Run on initial load
  if (window.innerWidth <= 991) {
    var hdrtop = document.querySelector('.hdrtop');
    var tright = document.querySelector('.tright');
    if (hdrtop && tright && !tright.contains(hdrtop)) {
        tright.prepend(hdrtop);
    }
  }
  document.querySelectorAll('.hdrtop .search-modal .modal-overlay, .hdrtop .search-modal__close-button').forEach(el => {
    el.addEventListener('click', () => {
        const details = document.querySelector('.header__search details');
        details.removeAttribute('open');
    });
  });
  
  
  // Bulk add
  class BulkAdd extends HTMLElement {
    constructor() {
      super();
      this.queue = [];
      this.requestStarted = false;
      this.ids = [];
    }
  
    startQueue(id, quantity) {
      this.queue.push({ id, quantity });
      const interval = setInterval(() => {
        if (this.queue.length > 0) {
          if (!this.requestStarted) {
            this.sendRequest(this.queue);
          }
        } else {
          clearInterval(interval);
        }
      }, 250);
    }
  
    sendRequest(queue) {
      this.requestStarted = true;
      const items = {};
      queue.forEach((queueItem) => {
        items[parseInt(queueItem.id)] = queueItem.quantity;
      });
      this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
      const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
      quickBulkElement.updateMultipleQty(items);
    }
  
    resetQuantityInput(id) {
      const input = this.querySelector(`#Quantity-${id}`);
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  
    setValidity(event, index, message) {
      event.target.setCustomValidity(message);
      event.target.reportValidity();
      this.resetQuantityInput(index);
      event.target.select();
    }
  
    validateQuantity(event) {
      const inputValue = parseInt(event.target.value);
      const index = event.target.dataset.index;
  
      if (inputValue < event.target.dataset.min) {
        this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
      } else if (inputValue > parseInt(event.target.max)) {
        this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
      } else if (inputValue % parseInt(event.target.step) != 0) {
        this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
      } else {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.startQueue(index, inputValue);
      }
    }
  
    getSectionsUrl() {
      if (window.location.pathname == '/search') {
          const urlParams = new URLSearchParams(window.location.search);
          const queryString = urlParams.get('q');
          return `${window.location.pathname}?q=${queryString}`;
      } else {
        if (window.pageNumber) {
          return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
          return `${window.location.pathname}`;
        }
      }
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }
  
  if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd);
  }
  document.addEventListener('DOMContentLoaded', function () {
    function changeBuyNowText() {
      const buyNowButtons = document.querySelectorAll('.shopify-payment-button__button--unbranded');
  
      buyNowButtons.forEach(button => {
        button.textContent = 'Buy Now';
      });
    }
  
    changeBuyNowText();
  
    setInterval(changeBuyNowText, 500);
  });
  // window.addEventListener("load", function () {
  //   const header = document.querySelector("header.header");
  
  //   let lastScroll = 0;
  //   let isHidden = false;
  
  //   const hideAfter = 150;   // hide trigger
  //   const showBefore = 100;  // show trigger (buffer zone)
  
  //   window.addEventListener("scroll", function () {
  //     const currentScroll = window.pageYOffset;
  
  //     const scrollingDown = currentScroll > lastScroll;
  
  //     // 🔴 Hide condition (only if scrolling down)
  //     if (scrollingDown && currentScroll > hideAfter && !isHidden) {
  //       header.classList.add("hide-header");
  //       isHidden = true;
  //     }
  
  //     // 🟢 Show condition (only if scrolling up + buffer zone)
  //     if (!scrollingDown && currentScroll < showBefore && isHidden) {
  //       header.classList.remove("hide-header");
  //       isHidden = false;
  //     }
  
  //     lastScroll = currentScroll;
  //   });
  // });
  
  window.addEventListener("load", () => {
  
      const header = document.querySelector(".header-wrapper");
  
      let lastScroll = 0;
      const hideAfter = 150;
  
      window.addEventListener("scroll", () => {
  
          const currentScroll = window.pageYOffset;
  
          if (currentScroll <= hideAfter) {
              header.classList.remove("hide-header");
          } else if (currentScroll > lastScroll) {
              // Scroll Down
              header.classList.add("hide-header");
          } else {
              // Scroll Up
              header.classList.remove("hide-header");
          }
  
          lastScroll = currentScroll;
      });
  
  });
  // document.addEventListener("DOMContentLoaded", () => {
  
  //   // Sirf enquiry products ke liye
  //   if (window.location.pathname.includes("/collections/")) {
  
  //     document.querySelectorAll(".card-wrapper").forEach(card => {
  
  //       // Agar product enquiry hai (abhi test ke liye Haemopack)
  //       const title = card.querySelector(".product-title a");
  
  //       if (title && title.textContent.trim() === "Haemopack") {
  
  //         // Price hide
  //         card.querySelector(".wbhprice")?.style.setProperty("display", "none", "important");
  
  //         // Add to cart hide
  //         card.querySelector(".product-form")?.style.setProperty("display", "none", "important");
  
  //         // Sale badge hide
  //         card.querySelector(".card__badge")?.style.setProperty("display", "none", "important");
  
  //         // Quick view hide (optional)
  //         card.querySelectorAll(".wbqvtop").forEach(el=>{
  //           el.style.setProperty("display","none","important");
  //         });
  
  //         // Enquire button add
  //         const inner = card.querySelector(".product-inner");
  
  //         if (inner && !card.querySelector(".collection-enquiry-btn")) {
  
  //           inner.insertAdjacentHTML("beforeend", `
  //             <a href="${title.href}"
  //                class="collection-enquiry-btn button button--primary"
  //                style="
  //                   display:block;
  //                   width:100%;
  //                   margin-top:15px;
  //                   text-align:center;
  //                   background:#000088;
  //                   color:#fff;
  //                   text-decoration:none;
  //                   padding:12px;
  //                   border-radius:6px;">
  //                Enquire Now
  //             </a>
  //           `);
  
  //         }
  
  //       }
  
  //     });
  
  //   }
  
  // });
  
  // document.querySelector('.wbpricetax')?.style.setProperty('display', 'none', 'important');

// Infinite Marquee Carousel
(function () {
  function initMarqueeCarousel(track) {
    if (track.dataset.marqueeInit) return;
    track.dataset.marqueeInit = 'true';

    const speed = parseFloat(track.dataset.marqueeSpeed) || 0.5; // px per frame
    const direction = track.dataset.marqueeDirection === 'right' ? 1 : -1;

    // Clone children until width is at least 2x container
    const container = track.parentElement;
    const originalItems = Array.from(track.children);
    if (originalItems.length === 0) return;

    function fillTrack() {
      const containerWidth = container.offsetWidth;
      let trackWidth = track.scrollWidth;
      while (trackWidth < containerWidth * 2 + 100) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
        trackWidth = track.scrollWidth;
        if (trackWidth > 10000) break; // safety
      }
    }

    fillTrack();

    let pos = direction === -1 ? 0 : -track.scrollWidth / 2;
    let animId;
    let paused = false;

    function animate() {
      if (!paused) {
        pos += speed * direction;
        const halfWidth = track.scrollWidth / 2;
        if (direction === -1 && Math.abs(pos) >= halfWidth) {
          pos = 0;
        } else if (direction === 1 && pos >= 0) {
          pos = -halfWidth;
        }
        track.style.transform = `translateX(${pos}px)`;
      }
      animId = requestAnimationFrame(animate);
    }

    // Pause on hover
    container.addEventListener('mouseenter', () => { paused = true; });
    container.addEventListener('mouseleave', () => { paused = false; });

    // Pause on touch
    container.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    container.addEventListener('touchend', () => { paused = false; }, { passive: true });

    animate();
  }

  function initAllMarquees() {
    document.querySelectorAll('.marquee-track, [data-marquee-track]').forEach(initMarqueeCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMarquees);
  } else {
    initAllMarquees();
  }

  // Also observe for dynamically added marquee tracks
  const observer = new MutationObserver(() => initAllMarquees());
  observer.observe(document.body, { childList: true, subtree: true });
})();